export const environment = {
    production: false,
    hmr: false,
    version: '2.4.0'
};